import { privateApi } from 'services/Api/ApiService';
import { CreateTalentNote, TalentNote, UpdateTalentNote } from './types';

const fetchTalentNotes = (talentId: string): Promise<TalentNote[]> =>
    privateApi.get<TalentNote[]>(`talents/${talentId}/notes`);

const createTalentNote = (payload: CreateTalentNote): Promise<TalentNote> =>
    privateApi.post<TalentNote>(`talent-notes`, payload);

const updateTalentNote = (noteId: string, payload: UpdateTalentNote): Promise<TalentNote> =>
    privateApi.put<TalentNote>(`talent-notes/${noteId}`, payload);

const deleteTalentNote = (talentId: string): Promise<void> => privateApi.delete<void>(`talent-notes/${talentId}`);

export const TalentNotesGateway = {
    fetchTalentNotes,
    createTalentNote,
    updateTalentNote,
    deleteTalentNote,
};
